import { getValueFromBrowser, AffiliateProduct } from "../js/trackingQueryHook.js";
import { getSiteApi } from '../js/session';

const getSiteConfig = async (type) => {
  const params = new URLSearchParams({ type });
  try {
    const response = await fetch(`${getSiteApi()}site/config?${params}`);
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Error:', error);
  }
};

export const getAppLink =  (needLinkForAndroidApp = false) => {
	const userProduct =
		+getValueFromBrowser('product') ||
		+getValueFromBrowser('product_1') ||
		+getValueFromBrowser('product_2') ||
		1;
	const isSportUser = userProduct === AffiliateProduct.Sport;
	if (needLinkForAndroidApp) {
    getSiteConfig('android').then(response => {
      if (response) {
        const androidAppLink = response?.android?.url;
        const link = isSportUser ? androidAppLink.sport : androidAppLink.casino;
        window.open(link, '_self');
      }
    });
	} else {
		const link = isSportUser
			? 'https://apps.apple.com/mx/app/winpot-sport/id6446956929'
			: 'https://apps.apple.com/mx/app/winpot-casino/id1632635281';
    window.open(link, '_blank');
	}
};
